module.exports = {
  siteTitle: 'Hyper Dynamo - Web Design', // <title>
  manifestName: 'Hyper-Dynamo',
  manifestShortName: 'Hyper Dynamo', // max 12 characters
  manifestStartUrl: '/',
  manifestBackgroundColor: '#000000',
  manifestThemeColor: '#000000',
  manifestDisplay: 'standalone',
  manifestIcon: 'src/assets/img/website-icon.png',
  pathPrefix: `/`, // This path is subpath of your hosting https://domain/portfolio
  heading: 'Hyper Dynamo Web Design',
  subHeading: 'Web development and software solutions for every business.',

  // social
/*   socialLinks: [
    {
      icon: 'fa-github',
      name: 'Github',
      url: 'https://github.com/anubhavsrivastava',
    },
    {
      icon: 'fa-linkedin-in',
      name: 'Linkedin',
      url: 'https://linkedin.com/in/theanubhav/',
    },
    {
      icon: 'fa-twitter',
      name: 'Twitter',
      url: 'https://twitter.com/onlyanubhav',
    },
  ], */
  email: 'info@hyperdynamo.com', 
/*   phone: '000-00000', */
  address: 'Chicago, IL', 
};
